import React from 'react';
import BasicIndex, { IndexItems } from 'buyside/components/presentation/Index/basicIndex';
import VisibilitySensor from 'react-visibility-sensor';
import LoadingSpinner, {
  SIZES
} from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import { useIsMobile } from 'buyside/util/hooks/useIsMobile';

const PaginatedIndexContext = React.createContext();

export class PaginationButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchNextPageLoading: false
    };
    this.toggleLoading = this.toggleLoading.bind(this);
  }

  toggleLoading() {
    this.setState(prevState => {
      return { fetchNextPageLoading: !prevState.fetchNextPageLoading };
    });
  }

  render() {
    const { children, hideLoading } = this.props;

    return (
      <PaginatedIndexContext.Consumer>
        {context => {
          const { hasNextPage, fetchNextPage } = context;

          const fetchNextPageWithLoading = () => {
            this.toggleLoading();
            const p = fetchNextPage();
            if (p instanceof Promise) {
              // let promise toggle loading to off
              p.then(this.toggleLoading);
            } else {
              // toggle loading off
              this.toggleLoading();
            }
          };

          if (!hasNextPage) {
            return null;
          }
          if (!hideLoading && this.state.fetchNextPageLoading) {
            return <LoadingSpinner size={SIZES.TINY} />;
          }
          if (children) {
            if (typeof children === 'function') {
              // render prop
              return children({ fetchNextPage: fetchNextPageWithLoading, hasNextPage });
            }
            return <div onClick={fetchNextPageWithLoading}>{children}</div>;
          } else {
            return (
              <div onClick={fetchNextPageWithLoading}>
                <button>Fetch Next Page</button>
              </div>
            );
          }
        }}
      </PaginatedIndexContext.Consumer>
    );
  }
}

export const PaginatedIndexItems = ({ className }) => {
  return (
    <PaginatedIndexContext.Consumer>
      {context => {
        const { indexItems } = context;
        const { indexItemRenderer } = context;
        return (
          <BasicIndex
            indexItems={indexItems}
            indexItemRenderer={indexItemRenderer}
            className={className}
            {...context}
          >
            <IndexItems />
          </BasicIndex>
        );
      }}
    </PaginatedIndexContext.Consumer>
  );
};

export const InfiniteScrollSpinner = () => {
  return (
    <PaginatedIndexContext.Consumer>
      {context => {
        const { hasNextPage, fetchNextPage } = context;
        if (!hasNextPage) {
          return '';
        } else {
          const onVisible = isVisible => {
            if (isVisible) {
              fetchNextPage();
            }
          };
          return (
            <VisibilitySensor onChange={onVisible}>
              <LoadingSpinner />
            </VisibilitySensor>
          );
        }
      }}
    </PaginatedIndexContext.Consumer>
  );
};

const PaginatedIndex = ({
  children,
  indexItems,
  indexItemRenderer,
  hasNextPage,
  fetchNextPage,
  ...props
}) => {
  const isMobile = useIsMobile();

  return (
    <div className="paginatedIndex">
      <PaginatedIndexContext.Provider
        value={{ indexItems, indexItemRenderer, hasNextPage, fetchNextPage, isMobile, ...props }}
      >
        {children}
      </PaginatedIndexContext.Provider>
    </div>
  );
};

export default PaginatedIndex;
